import * as app from '../../main';
import axios from 'axios';
import { ScrollPageHandler } from '../scroll-page';
import alertObject from "../notification/global-alerts";
import { AlertFactory } from "../notification/alert-factory";
import { CartItemsIndicator } from "../cart-items-indicator/cart-items-indicator";
import { Modal } from "../modals/modal";
var IndirectCheckout = /** @class */ (function () {
    function IndirectCheckout() {
        this.SendToDealerTypes = {
            DEALER_FROM_FAVORITES: 'DEALER_FROM_FAVORITES',
            OTHER: 'OTHER',
        };
        this.$pageIndirectCheckout = document.querySelector('.o-indirectCheckout');
        this.onlineDealer = 'true' == this.$pageIndirectCheckout.getAttribute('data-online-dealer');
        this.$checkoutBtns = document.querySelectorAll('.a-greenBlueBtn');
        this.$form = document.querySelector('#indirectCheckoutForm');
        this.showDealerSection = 'true' === this.$pageIndirectCheckout.getAttribute('data-dealer-section');
        this.isCustomerDropshipping = 'true' === this.$pageIndirectCheckout.getAttribute('data-customer-dropshipping');
        this.$dealerRadioButtons = this.$pageIndirectCheckout.querySelectorAll('input[type=radio][name=sendToDealerType]');
        this.$dealerCodeElement = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__dealer__code');
        this.$dealerCodeSelect = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__dealer__code .a-customSelect');
        this.$dealerCodeInput = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__dealer__code .a-customSelect__field__input--hidden');
        this.$dealerEmailElement = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__dealer__email');
        this.$dealerEmailInput = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__dealer__email input');
        this.$dealerAgreementInput = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__dealer__agreement input');
        this.$billingAddress = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__billingAddress');
        this.$billingAddressNotice = this.$pageIndirectCheckout.querySelector('.o-indirectCheckout__billingAddressNotice');
        this.$modal = document.querySelector('#removeDealersProductModal');
        this.$productName = this.$modal.querySelector('.m-dealersProductModal__content__table__data__first--name');
        this.$sku = this.$modal.querySelector('.m-dealersProductModal__content__table__data__second--sku');
        this.$productQuantity = this.$modal.querySelector('.m-dealersProductModal__content__table__data__second--quantity');
        this.$productImage = this.$modal.querySelector('.m-dealersProductModal__content__table__data__first--img');
        this.$confirmModalButton = this.$modal.querySelector('.a-darkBtn');
        this.$closeModalBtn = this.$modal.querySelector('.m-modal__content__close');
        this.$redirectLink = this.$modal.querySelector('.m-dealersProductModal__redirect');
        this.alertFactoryObject = new AlertFactory();
        this.init();
    }
    IndirectCheckout.prototype.submitFormOnClickWhenPossible = function (event) {
        if (this.$form.checkValidity()) {
            this.commonSubmitForm(event);
        }
    };
    IndirectCheckout.prototype.submitFormWithDealer = function (event) {
        var $button = event.currentTarget;
        var targetModal = $button.getAttribute('target-modal');
        var dealerModal = document.querySelector(".m-modal[id=\"".concat(targetModal, "\"]"));
        event.preventDefault();
        app.default.getValidation(this.$form.id).validateFields();
        if (!this.$form.checkValidity()) {
            this.scrollToDealerSection();
            return;
        }
        if (this.onlineDealer) {
            var modalArr = app.default.getModalArr();
            var modalObj = modalArr.find(function (modal) { return modal.element == dealerModal; });
            modalObj.obj.showModal();
        }
        else {
            this.commonSubmitForm(event);
        }
    };
    IndirectCheckout.prototype.commonSubmitForm = function (event, dealersProductValidation) {
        if (dealersProductValidation !== true && this.isCustomerDropshipping === true && this.$dealerCodeInput.required === true) {
            this.validateDealerProducts(event);
        }
        else {
            this.$form.submit();
        }
    };
    IndirectCheckout.prototype.validateDealerProducts = function (ev) {
        var _this = this;
        var preferredDealerId = this.$dealerCodeInput.value;
        var requestUrl = '/checkout/validateproducts';
        var data = { preferredDealer: preferredDealerId };
        axios.post(requestUrl, data)
            .then(function (response) {
            var _a;
            if (response.data.length > 0) {
                _this.$productName.innerHTML = response.data[0].product.baseProductDisplayName === null
                    ? response.data[0].product.displayName
                    : "".concat(response.data[0].product.baseProductDisplayName, " ").concat(response.data[0].product.displayName);
                _this.$productQuantity.innerHTML = response.data[0].quantity;
                _this.$sku.innerHTML = response.data[0].product.code;
                response.data[0].product.images !== null && _this.$productImage.setAttribute('src', (_a = response.data[0].product.images[0]) === null || _a === void 0 ? void 0 : _a.url);
                _this.addModal(ev);
            }
            else {
                _this.commonSubmitForm(ev, true);
            }
        })
            .catch(function (error) {
            console.log(error);
            var message = 'Error occured during order simulation.<br />Please contact Ordering Tool Power User.';
            var element = _this.alertFactoryObject.createAlert(message, window.ACC.status.error, 'error', { 'animated': true, 'closable': true });
            alertObject.showAlert(element);
        });
    };
    IndirectCheckout.prototype.deleteDealerUnsellableProducts = function () {
        var _this = this;
        axios.get('/checkout/removeproducts ')
            .then(function (response) {
            new CartItemsIndicator();
            (response === null || response === void 0 ? void 0 : response.data) === "Empty cart" ? _this.$redirectLink.click() : _this.$closeModalBtn.click();
        })
            .catch(function (error) {
            console.log(error);
        });
    };
    IndirectCheckout.prototype.addModal = function (ev) {
        ev.preventDefault();
        var modal = new Modal(document.querySelector('.m-modal#removeDealersProductModal'));
        modal.showModal();
    };
    IndirectCheckout.prototype.toggleDealerOption = function (event) {
        var _this = this;
        var option = event.currentTarget;
        if (option.value === this.SendToDealerTypes.DEALER_FROM_FAVORITES) {
            this.$dealerCodeElement.classList.remove('o-indirectCheckout__dealer__code--hidden');
            this.$dealerCodeInput.required = true;
            this.$dealerEmailElement.classList.add('o-indirectCheckout__dealer__email--hidden');
            this.$dealerEmailInput.required = false;
            if (this.isCustomerDropshipping) {
                this.$billingAddress.classList.add('o-indirectCheckout__billingAddress--hidden');
                this.$billingAddressNotice.classList.remove('o-indirectCheckout__billingAddressNotice--hidden');
            }
            this.$dealerEmailInput.value = '';
            var fieldToValidate = this.$dealerEmailElement.querySelector('.a-input');
            app.default.getValidation(this.$form.id).initValidationResult(fieldToValidate, 'a-input');
        }
        else if (option.value === this.SendToDealerTypes.OTHER) {
            this.$dealerCodeElement.classList.add('o-indirectCheckout__dealer__code--hidden');
            this.$dealerCodeInput.required = false;
            this.$dealerEmailElement.classList.remove('o-indirectCheckout__dealer__email--hidden');
            this.$dealerEmailInput.required = true;
            if (this.isCustomerDropshipping) {
                this.$billingAddress.classList.remove('o-indirectCheckout__billingAddress--hidden');
                this.$billingAddressNotice.classList.add('o-indirectCheckout__billingAddressNotice--hidden');
            }
            var selectArr = app.default.getSelectArr();
            var selectObj = selectArr.find(function (select) { return select.element == _this.$dealerCodeSelect; });
            selectObj.obj.unselectOption();
            var fieldToValidate = this.$dealerCodeSelect.querySelector('.a-input');
            app.default.getValidation(this.$form.id).initValidationResult(fieldToValidate, 'a-input');
        }
        this.updateSubmitButton();
    };
    IndirectCheckout.prototype.updateSubmitButton = function () {
        if (this.$form.checkValidity()) {
            this.$checkoutBtns.forEach(function (btn) { return btn.classList.remove('a-greenBlueBtn--clickableDisabled'); });
        }
        else {
            this.$checkoutBtns.forEach(function (btn) { return btn.classList.add('a-greenBlueBtn--clickableDisabled'); });
        }
    };
    IndirectCheckout.prototype.scrollToDealerSection = function () {
        var scrollPageObject = new ScrollPageHandler();
        scrollPageObject.scrollPage('.o-indirectCheckout__dealer');
    };
    IndirectCheckout.prototype.init = function () {
        var _this = this;
        if (this.showDealerSection) {
            this.$dealerCodeInput.addEventListener('customSelectValueChanged', function () { return _this.updateSubmitButton(); });
            this.$dealerEmailInput.addEventListener('blur', function () { return _this.updateSubmitButton(); });
            this.$dealerAgreementInput.addEventListener('change', function () { return _this.updateSubmitButton(); });
            this.$checkoutBtns.forEach(function (button) {
                button.addEventListener('click', function (event) { return _this.submitFormWithDealer(event); });
            });
        }
        else if (!this.onlineDealer) {
            this.$checkoutBtns.forEach(function (button) {
                button.addEventListener('click', function (event) { return _this.submitFormOnClickWhenPossible(event); });
            });
        }
        this.$dealerRadioButtons.forEach(function (option) {
            option.addEventListener('click', function (event) { return _this.toggleDealerOption(event); });
        });
        this.$confirmModalButton.addEventListener('click', function (event) { return _this.deleteDealerUnsellableProducts(); });
    };
    return IndirectCheckout;
}());
export { IndirectCheckout };
